module.exports = __webpack_public_path__ + "fonts/TTFirs-ExtraBold.6d41714c.eot";